import { render, staticRenderFns } from "./PermissionListFilter.vue?vue&type=template&id=7422db50&scoped=true&"
import script from "./PermissionListFilter.vue?vue&type=script&lang=js&"
export * from "./PermissionListFilter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7422db50",
  null
  
)

export default component.exports